import React from 'react'

import { MenuRecipe } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { Ingredients } from './Ingredients'

import css from '../Detail.css'

type DetailIngredientsProps = {
  recipe: MenuRecipe
  loading: boolean
}

export const DetailIngredients = ({ recipe, loading }: DetailIngredientsProps) => {
  const { ingredients } = recipe

  if (ingredients.length === 0) {
    return null
  }

  return (
    <div className={css.sectionPanel}>
      <Ingredients loading={loading} ingredients={ingredients} />
    </div>
  )
}
